import intl from 'react-intl-universal'
import * as S from './styled'
import PropTypes from 'prop-types'
import Button from 'components/button'

export const FilterActions = ({ handleClickClean, handleClickSearch, disabledSearch }) => (
  <S.WrapperActions>
    <Button
      buttonType="primary"
      onClick={handleClickSearch}
      value={intl.get('filters.search')}
      className="btn-close-search"
      disabled={disabledSearch}
    />
    <Button
      buttonType="default"
      onClick={handleClickClean}
      value={intl.get('filters.cleanSearch')}
      className="btn-clean"
    />
  </S.WrapperActions>
)

FilterActions.propTypes = {
  disabledSearch: PropTypes.bool,
  handleClickSearch: PropTypes.func,
  handleClickClean: PropTypes.func
}